// extracted by mini-css-extract-plugin
export default {"button":"TipAmountButton_button__BlLu-","selected":"TipAmountButton_selected__fHx+I"};